import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Manufacturing & Distribution', href: '/manufacturing-and-distribution' },
  { label: 'Products & Services', href: '/products-and-services' },
  { label: 'Contact Us', href: '/contact-us' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const forcedWhite = !isHome || scrolled;

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        forcedWhite ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
        <Link to="/" className="cursor-pointer flex items-center">
          <img
            src="https://storage.readdy-site.link/project_files/ef2cd86a-0c8c-43d9-a80f-76980d5cdfeb/efd1c1b3-eb7c-4977-9e9d-97ff5b41d004_OnPoint-Logo-Red-White-and-Blue.png?v=a3ea8d6e61ccf94fd7ba238e66b5c0b3"
            alt="OnPoint USA"
            className="h-12 w-auto"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.href;
            return (
              <Link
                key={link.label}
                to={link.href}
                onClick={() => setMenuOpen(false)}
                className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer pb-0.5 border-b-2 ${
                  isActive
                    ? 'border-red-600 text-red-600'
                    : forcedWhite
                    ? 'border-transparent text-gray-700 hover:text-red-600'
                    : 'border-transparent text-white hover:text-red-200'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 transition-colors ${forcedWhite ? 'bg-gray-800' : 'bg-white'}`} />
          <span className={`block w-6 h-0.5 transition-colors ${forcedWhite ? 'bg-gray-800' : 'bg-white'}`} />
          <span className={`block w-6 h-0.5 transition-colors ${forcedWhite ? 'bg-gray-800' : 'bg-white'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white shadow-lg px-6 pb-6 pt-2">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.href}
              onClick={() => setMenuOpen(false)}
              className={`block w-full text-left py-3 text-sm font-medium border-b border-gray-100 last:border-0 cursor-pointer whitespace-nowrap ${
                location.pathname === link.href ? 'text-red-600' : 'text-gray-700 hover:text-red-600'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
